import React, { useEffect, useState } from 'react'
import Flex from 'typescript-styled-flex'
import { useTranslation } from 'react-i18next'
import Modal from '../../components/Template/Modal'
import PremiumStart from '../../assets/premium/premium_start.png'
import styled from '../../theme'
import Button from '../../components/Template/Button'
import { is } from '../../components/MediaQuery'

const Header = styled.div`
  font-weight: bold;
  font-size: 18px;
`

function CriticalErrorModal({ open }) {
  const { t } = useTranslation()
  const isDesktop = is.desktop()
  const [ref, setRef] = useState(null as HTMLSpanElement)

  useEffect(() => {
    if (ref) {
      const element = Array.from(ref.children).find(
        child => child.tagName === 'A',
      )
      if (element) {
        element.setAttribute('target', '_blank')
      }
    }
  })

  const reload = () => window.location.reload()

  return (
    <Modal
      style={{
        borderRadius: '11px',
        margin: '0 10px',
        maxWidth: '804px',
        padding: 0,
        transform: `translateY(${isDesktop ? '-20vh' : 0})`,
        width: isDesktop ? '804px' : 'unset',
      }}
      containerStyle={{
        zIndex: 150000,
      }}
      onClose={null}
      open={open}
    >
      <Flex full={true} row={isDesktop} columnReverse={!isDesktop}>
        <img
          alt={'new version'}
          style={{
            borderRadius: isDesktop ? '10px 0 0 10px' : 'unset',
            height: '250px',
            maxWidth: isDesktop ? '396px' : '410px',
            width: 'auto',
          }}
          src={PremiumStart}
        />
        <Flex
          full={true}
          justifyBetween={true}
          alignCenter={true}
          style={{ maxWidth: '410px', minHeight: '250px', padding: '1.5em' }}
          column={true}
        >
          <Header>{t('BBO_2858_unknown_error')}</Header>
          <span
            ref={setRef}
            style={{
              fontSize: '16px',
              lineHeight: '1.4',
              padding: '0 20px',
              textAlign: 'center',
            }}
          >
            {t('error_server_response_2')}
          </span>
          <Button onClick={reload} style={{ width: '100%' }} primary={true}>
            {t('z5018_refresh')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

export default CriticalErrorModal
